import React from 'react'

import { Button, Column, Row, Text } from 'Components/UI'

import { LocationGlyph, MailGlyph, PhoneGlyph } from 'Assets/Svg/Icons'

import {
  ADDRESS,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_HREF,
} from 'Constants/Contact'
import { GOOGLE_MAPS_QUERY_TEMPLATE } from 'Constants/ExternalLinks'

import { useAppContext } from 'Services/AppContext'

import { Strong, StyledLink } from './styles'

function FooterContacts() {
  const { openSupportWidget } = useAppContext()

  return (
    <Column py={7}>
      <Text as="h2" invertedTitle mb={3} medium title40>
        <Strong>Start with</Strong> a paid discovery
      </Text>
      <Text body16 invertedBody mb={7} semiLight>
        Two weeks, fixed fee. You keep the document whether or not we build.
      </Text>

      <Row>
        <Button height="48px" type="button" onClick={openSupportWidget}>
          <Text as="span" body16 invertedBody medium>
            Book a paid discovery
          </Text>
        </Button>
      </Row>

      <Column gap={4} mt={17}>
        <StyledLink href={`mailto:${CONTACT_EMAIL}`}>
          {MailGlyph()}

          <Text as="span" body16 medium>
            {CONTACT_EMAIL}
          </Text>
        </StyledLink>

        <StyledLink href={`tel:${CONTACT_PHONE_HREF}`}>
          {PhoneGlyph()}

          <Text as="span" body16 medium>
            {CONTACT_PHONE}
          </Text>
        </StyledLink>

        <StyledLink
          href={`${GOOGLE_MAPS_QUERY_TEMPLATE}${ADDRESS.AU.COORDS}`}
          target="_blank"
        >
          {LocationGlyph()}

          <Text as="span" body16 medium>
            {ADDRESS.AU.TEXT}
          </Text>
        </StyledLink>
      </Column>
    </Column>
  )
}

export default FooterContacts
